export enum InvoiceStatusEnum {
  INVOICED = 'INVOICED',
  OVERDUE = 'OVERDUE',
  PAID = 'PAID',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  VOIDED = 'VOIDED',
  EXTERNALLY_MANAGED = 'EXTERNALLY_MANAGED',
}
